
/**
 * @typedef {Object} RxBarrel
 * @property $start When barrel starts rotating.
 * @property {Object} $stop When barrel stops rotating. .data is data to stop barrel with (symbols, wins, etc.), .interrupted is true if rotation was interrupted by user.
 * */
/**
 * Barrel driver.
 * @param $spin Barrel data to display when spins stop.
 * @param $initiate Attempts to start barrel rotations.
 * @param $interruptUser When barrel rotation must interrupt by user interaction.
 * @param $requestSink Data requests to stop barrel rotations with.
 * @param min Barrel minimal rotation duration SECONDS.
 * @param max Barrel rotation interruption by timeout when data to stop spinning is already present. In seconds.
 * @return {RxBarrel}
 * */
export default function(
    parent,
    $spin,
    max = 0.320,
)
{
    const space = parent.child( "barrel" );
    
    const $stop = space.s( "stop" );
    const $initiate = space.s( "initiate" ).desc( 'Вызывается когда ИГРОК запускает спин. Не будет вызываться при восстановлении состояния на вращающемся барабане: для этого можно использовать stop' );
    const $interruptUser = space.s( "interruptUser" );
    const $request = space.s( "request" );
    
    const $pendingSpin = space.s( "pendingSpin", undefined, true );
    
    const $pendingInterrupt = space.s( "pendingInterrupt" )
    $stop.map( () => undefined ).to( $pendingInterrupt )
    
    var interruptByUser = false;
    const $tryStop = space.s( "tryStop" );
    $tryStop
        .with(
            $pendingSpin,
            $pendingInterrupt,
            ( _, pendingSpin, pendingInterrupt ) => ({ pendingSpin, pendingInterrupt })
        )
        .filter( ({ pendingSpin, pendingInterrupt }) => pendingSpin && pendingInterrupt )
        .map( ({ pendingSpin, pendingInterrupt }) => ({ data : pendingSpin, interrupted : interruptByUser }) )
        .to( $stop )
    
    $interruptUser.subscribe( () => interruptByUser = true );
    
    const $start = space.s( "start" ).desc( 'Вызывается при начале вращения барабанов независимо от того запустил их игрок или это восстановление состояния на вращающихся барабанах' );
    //interrupt:
    $start
        .delay( max * 1000 )
        .merge( $interruptUser )
        .subscribe( () => {
            $pendingInterrupt.next( true )
            $tryStop.next();
        } )
    //true when barrel currently spinning or false otherwise:
    const $spinning = space.s( "spinning", false );
    $start
        .map( () => true )
        .merge( $stop.map( () => false ) )
        .distinctUntilChanged()
        .to( $spinning );
    
    $initiate.subscribe( request =>
    {
        $pendingSpin.next();
        $start.next();
        $request.next();
    } );
    
    $spin
        .with( $spinning, ( spin, spinning ) => ({ spin, spinning }) )
        .on( ({ spin, spinning }) =>
        {
            $pendingSpin.next( spin );
            
            //spinning:
            if ( spinning )
            {
                $tryStop.next();
            }
            //implementing monitoring and state recovery:
            else
            {
                $start.next( spin );
            }
        } )
    
    $start.subscribe( () => interruptByUser = false );
    
    $pendingSpin
        .map( pendingSpin => pendingSpin !== undefined )
        .subscribe( space.s( "hasData" ) );
    
    return space;
}



// WEBPACK FOOTER //
// ./src/library/rx_barrel.es6